import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React from "react";
import "../../PlanningApplication.css";

interface IsAnonymousRadioButtonsProps {
    remainAnonymous: string;
    remainAnonymousOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const IsAnonymousRadioButtons: React.FC<IsAnonymousRadioButtonsProps> = ({ remainAnonymous, remainAnonymousOnChange }) => {
    return (
        <FormControl className="comments__radio-buttons-container">
            <FormLabel id="anonymous-radio-buttons-label">Do you wish to remain anonymous?</FormLabel>
            <RadioGroup className="comments__radio-buttons-container" aria-labelledby="anonymous-radio-buttons-label" defaultValue="no" name="anonymous-radio-group">
                <FormControlLabel value="no" control={<Radio checked={remainAnonymous === "no"} onChange={remainAnonymousOnChange} />} label="No" />
                <FormControlLabel value="yes" control={<Radio checked={remainAnonymous === "yes"} onChange={remainAnonymousOnChange} />} label="Yes" />
            </RadioGroup>
        </FormControl>
    );
};

export default IsAnonymousRadioButtons;
